import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import abc from "./thank.png";
import "./App.css";

function ThankYou() {
  const [queryParams, setQueryParams] = useState({});
  const navigate = useNavigate();

  useEffect(() => {


    const getQueryParams = () => {
        // Fire Google Ads conversion event
        window.gtag?.("event", "conversion", {
        send_to: "AW-773249637/yUY1CPCiuJIZEOW02_AC",
      });
      const searchParams = new URLSearchParams(window.location.search);
      const params = {
        moid: searchParams.get("request_order_id"),
        currency: searchParams.get("currency") || "INR" ,
        amount: searchParams.get("amount") || 0
      };

      // Set the query parameters in the state
      setQueryParams(params);

      // If any of the required parameters are missing, redirect to the homepage
      if (!params.moid || !params.currency || !params.amount) {
        setTimeout(() => {
          navigate("/");
        }, 7000); // 7 second delay
        
      }
 
    };

    getQueryParams();
    

  }, [navigate]);
  return (
    <>
      <div className="container-fluid qwert" style={{ color: "white" }}>
        <div className="row w-100">
          <section className="w-100 main-section">
            <div className="main-page-con m-auto">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="thank-you-div">
                  <img src={abc} alt="" width={100} height={100} />
                  <div className="thank-you-card w-100 mt-2">
                    <p style={{fontSize:22}}>
                      Thank you for taking the 1st right step towards your dream
                      home.
                    </p>
                    <p>
                      <ul>
                        <li style={{fontSize:17}}>Order Id: <span  style={{fontSize:15,display: "block", marginTop: 4}}>{queryParams.moid}</span></li>
                        {/* <li>Payment Id: {queryParams.pid}</li> */}
                        <li style={{fontSize:17}}>Status: <span style={{fontSize:15,display: "block", marginTop: 4}}>Success</span></li>
                        {/* <li>Currency: {queryParams.currency}</li> */}
                        <li style={{fontSize:17}}>
                          Amount: <span  style={{fontSize:15,display: "block", marginTop: 4}}>{queryParams.currency}{queryParams.amount}</span>
                        </li>
                      </ul>
                    </p>
                    <p style={{fontSize:20}}>
                      you will soon receive your plan on whatsapp.
                    </p>
                    {/* <p style={{color:'red'}}>Note:Due to Diwali Holidays your AI Floor Plan will be delivered to you by 5th November 2025 to 6th November 2025</p> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>{" "}
    </>
  );
}

export default ThankYou;
